<template>
  <div class="page-wrapper newslist-page newsdetail-page">
    <div class="container">
      <a-row :gutter="[32, 32]">
        <a-col :lg="17">
          <div class="news-detail">
            <BaseLoading  opaque :spinning="singleNewsLoading" size="large">
              <div class="news-image">
                <img
                  :src="generateImageUrl(singleNews.image)"
                  alt="News image"
                />
              </div>
              <div class="news-text-detail">
                <div class="extra-info">
                  <div class="date-info">
                    <a-icon type="clock-circle" />{{
                      singleNews.createdAt | humanizeDate
                    }}
                  </div>
                  <div class="tags-info">
                    <a-icon type="folder-open" />{{
                      singleNews.category
                        .map(cat => cat.categoryName)
                        .join(", ")
                    }}
                  </div>
                </div>
                <div class="news-title">
                  {{ singleNews.title }}
                </div>
                <div
                  class="news-description"
                  v-html="singleNews.description"
                ></div>
                <div class="extra-info tags">
                  <span>Tags :</span>
                  <ul class="list tag-list">
                    <li v-for="(tag, index) in singleNews.tags" :key="index">
                      {{ tag.tagName }}
                    </li>
                  </ul>
                </div>
                <div class="social-share extra-info tags">
                  <span>Share this news :</span>
                  <ul class="list">
                    <li class="fb">
                      <div
                        class="fb-share-button"
                        :data-href="newsUrl"
                        data-layout="button"
                        data-size="small"
                      >
                        <a
                          target="_blank"
                          :href="facebookUrl"
                          class="fb-xfbml-parse-ignore"
                          ><a-icon type="facebook"
                        /></a>
                      </div>
                    </li>
                    <li class="twitter">
                      <a
                        target="_blank"
                        :href="twitterUrl"
                        class="twitter-share-button"
                      >
                        <a-icon type="twitter" />
                      </a>
                    </li>
                    <li class="linkedin">
                      <a target="_blank" :href="linkedinUrl">
                        <a-icon type="linkedin" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </BaseLoading>
          </div>
        </a-col>
        <a-col :lg="7">
          <NewsSideBar
            @search="value => handleNewsSearch(value)"
            @category-click="id => handleCategoryClick(id)"
            @tag-click="id => handleTagClick(id)"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import NewsSideBar from "./sidebar";
import { mapGetters } from "vuex";

const STORE_KEY = "newsStore";

export default {
  name: "NewsDetail",
  props: ["news"],
  components: {
    NewsSideBar
  },
  computed: {
    ...mapGetters({
      singleNews: `${STORE_KEY}/singleNews`,
      singleNewsLoading: `${STORE_KEY}/singleNewsLoading`
    }),
    newsUrl() {
      return `${this.baseUrl}/api/v1/extra/news/getHtml/${this.$route.params.id}`;
    },
    facebookUrl() {
      return `https://www.facebook.com/sharer/sharer.php?${new URLSearchParams({
        u: this.newsUrl
      }).toString()}`;
    },
    twitterUrl() {
      return `https://twitter.com/intent/tweet?${new URLSearchParams({
        url: this.newsUrl
      }).toString()}`;
    },
    linkedinUrl() {
      return `https://linkedin.com/sharing/share-offsite/?${new URLSearchParams(
        {
          url: this.newsUrl
        }
      )}`;
    }
  },
  async mounted() {
    await this.$store.dispatch(`${STORE_KEY}/getNews`, { sort: "-createdAt" });
    await this.$store.dispatch(`${STORE_KEY}/getSingleNews`, {
      id: this.$route.params.id
    });
  },
  methods: {
    handleTagClick(tagId) {
      this.$router.push({ path: "/news", query: { tag_id: tagId } });
    },
    handleCategoryClick(categoryId) {
      this.$router.push({ path: "/news", query: { category_id: categoryId } });
    },
    handleNewsSearch(value) {
      this.$router.push({ path: "/news", query: { q: value } });
    }
  },
  watch: {
    "$route.params": {
      deep: true,
      handler: function(newVal) {
        this.$store.dispatch(`${STORE_KEY}/getSingleNews`, { id: newVal.id });
      }
    }
  }
};
</script>
<style lang="scss">
.newsdetail-page {
  .news-detail {
    background: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0px 4px 10px 5px rgba(209, 209, 209, 0.6);
    min-height: 500px;
    .news-image {
      width: 100%;
      height: 400px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .news-loading {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
    }
    .news-text-detail {
      padding: 30px 60px;
      .extra-info {
        padding-bottom: 20px;
        margin-bottom: 35px;
        border-bottom: 1px solid #dddddd;
        display: flex;
        align-items: center;
        > div {
          margin-right: 15px;
          font-size: 14px;
          color: #7a8b91;
          font-weight: 500;
          .anticon {
            color: #d73228;
            margin-right: 8px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
        &.tags {
          padding: 30px 0;
          align-items: center;
          span {
            font-size: 14px;
            font-weight: 500;
            text-transform: uppercase;
            color: #000;
            padding-right: 20px;
          }
          .tag-list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 0;
            padding: 0;
            list-style: none;
            li {
              padding: 0 10px;
              border-radius: 4px;
              font-size: 14px;
              font-weight: 400;
              line-height: 28px;
              color: #8d8d8d;
              text-transform: lowercase;
              margin-right: 5px;
              margin-bottom: 5px;
              display: block;
              border: 1px solid #ddd;
            }
          }
        }
        &.social-share {
          padding: 0;
          border: none;
          .list {
            margin: 0;
            padding: 0;
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            li {
              margin-right: 20px;
              i {
                font-size: 20px;
                background: #ffffff;
                height: 23px;
              }
              &.fb {
                i {
                  color: #3b5998;
                }
              }
              &.twitter {
                i {
                  color: #00acee;
                }
              }
              &.linkedin {
                i {
                  color: #0e76a8;
                }
              }
              &.insta {
                i {
                  color: #dd2a7b;
                }
              }
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
      .news-title {
        font-size: 22px;
        font-weight: 500;
        color: #000;
        margin-bottom: 25px;
      }
      .news-description {
        p {
          font-weight: 400;
          font-size: 16px;
          color: rgb(0, 0, 0);
          margin-bottom: 15px !important;
        }
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .newsdetail-page {
    .news-detail {
      .news-text-detail {
        padding: 20px 30px;
        .extra-info {
          padding-bottom: 10px;
          margin-bottom: 25px;
          flex-direction: column;
          > div {
            margin-right: 0px;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          &.tags {
            padding: 20px 0;
            span {
              padding-right: 0px;
              padding-bottom: 10px;
            }
          }
        }
        .news-title {
          text-align: center;
          font-size: 20px;
          margin-bottom: 20px;
        }
        .news-description {
          p {
            text-align: center;
            margin-bottom: 10px !important;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 575px) {
  .newsdetail-page {
    .news-detail {
      .news-image {
        height: 300px;
      }
    }
  }
}
</style>
